export default "__VITE_ASSET__CMGpWVoo__"